import styled from "styled-components";
import { calculateRem } from "@uie/javascript-style-helpers";

const Select = styled.select.attrs(({ locked, disabled }) => ({
  disabled: locked || disabled ? true : false
}))`
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  height: ${calculateRem(50)};
  vertical-align: top;

  margin: 0;
  min-width: ${calculateRem(160)};
  padding: ${calculateRem(15)};

  background-color: ${({ theme }) => theme.secondary};
  border-radius: 0;
  color: ${({ theme }) => theme.primary};

  font-size: ${calculateRem(14)};
  font-family: ${({ theme }) => theme.fontFamily};
  font-weight: normal;
  line-height: ${calculateRem(16)};

  border-top: ${calculateRem(1)} solid ${({ theme }) => theme.coolGray3};
  border-right: ${calculateRem(1)} solid ${({ theme }) => theme.coolGray3};
  border-left: ${calculateRem(1)} solid ${({ theme }) => theme.coolGray3};
  border-bottom: 0.0625rem solid ${({ theme }) => theme.black};
  appearance: none;

  ${({ error, theme }) =>
    error &&
    `
    border-color: ${theme.error}
    border-bottom-width: ${calculateRem(4)};
    padding-bottom: ${calculateRem(12)};
    color: ${theme.black};
  `};

  &:focus {
    outline: none;
    border: ${calculateRem(1)} solid ${({ theme }) => theme.black};
  }

  &:not([multiple]) {
    background-color: transparent;
    background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='13px' height='6px' viewBox='0 0 13 6' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com --%3E%3Ctitle%3EArrow down%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Symbols' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Dropdown-Default' transform='translate(-106.000000, -40.000000)' stroke='%23000000'%3E%3Cg transform='translate(0.000000, 8.000000)' id='Arrow-down'%3E%3Cg transform='translate(107.000000, 32.000000)'%3E%3Cpolyline id='Shape' points='0 0 5.6 5.8 11.2 0'%3E%3C/polyline%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 8px center;
    background-size: ${calculateRem(12, 6)};
    padding: ${calculateRem(15, 42, 15, 15)};

    ${({ error, theme }) =>
      error &&
      `
    border-color: ${theme.error}
    border-bottom-width: ${calculateRem(4)};
    padding-bottom: ${calculateRem(12)};
    color: ${theme.black};
    background-position-y: ${calculateRem(21)};
  `};
  }

  ${({ disabled, theme }) =>
    disabled &&
    `
    border-color: ${theme.disabled};
    &:not([multiple]) {
      background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='13px' height='6px' viewBox='0 0 13 6' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com --%3E%3Ctitle%3EArrow down%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Symbols' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Dropdown-Default' transform='translate(-106.000000, -40.000000)' stroke='%23d8dada'%3E%3Cg transform='translate(0.000000, 8.000000)' id='Arrow-down'%3E%3Cg transform='translate(107.000000, 32.000000)'%3E%3Cpolyline id='Shape' points='0 0 5.6 5.8 11.2 0'%3E%3C/polyline%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    }
  `};

  ${({ locked }) =>
    locked &&
    `
    border: none;
    &:not([multiple]) {
      background-image: none;
      padding-left: 0;
    }
  `};
`;

export default Select;
